module.exports = __webpack_public_path__ + "4db6eb187c9f609b6574b24fdc15e1b9.png";